module.exports = __webpack_public_path__ + "media/arrows/down-arrow-1db27137.svg";